const poleColourOption = '.sw_858351_342509';   

const helpMessages = {
  ExactTrackLength: "Select the length range in mm which your curtain track would sit within. <br> <b>e.g. required length = 2750mm</b> therefore, select “<b>Track Length = 2501-3000</b>”. We recommend that you increase the width of the window length by 30% to account for curtain stack and minimise light blocking when the curtains are open, this is only a recommendation and you should use your own judgment. ",
  FixingType: "Select your desired bracket type: <br> <b>Ceiling fix</b> – Brackets are mounted to a horizontal fixing surface. <br> <b>Wall fix</b> – Brackets are mounted to a vertical fixing surface. <br> <b>Wall fix adjustable</b> – Brackets are mounted to a vertical fixing surface with an adjustable projection of 75mm to 100mm.  See ACCESSORIES for more details.",
  GliderType: "Select your desired glider type: <br> <b>Standard</b> – Standard glider low noise nylon wheels with stainless steel eye. <br> <b>60mm wave</b> – Ultra low noise nylon wheels with 60mm integrated wave cord. Stack size of 15mm with plastic ring and swivel action. Heavy duty runner for use on all tracks including bay windows. <br> <b>80mm wave</b> – Ultra low noise nylon wheels with 80mm integrated wave cord. Stack size of 15mm with plastic ring and swivel action. Heavy duty runner for use on all tracks including bay windows. ",
  GliderTypePole: "Select your desired glider type: <br> <b>Standard</b> – Standard glider low noise nylon wheels with stainless steel eye. <br> <b>60mm wave</b> – Ultra low noise nylon wheels with 60mm integrated wave cord. Stack size of 15mm with plastic ring and swivel action. Heavy duty runner for use on all tracks including bay windows.",
  ExactTrackLength: "Enter the exact required length to the nearest mm.",
  NumberofCurtains: "Select your desired number of curtains: <br> <b>Single curtain</b> – The curtain will open to the left or right from one side. <br> <b>Pair of curtains</b> – The curtain will open from the middle outwards. ",
  RemoteControl: "Select your desired remote control type, click the “Choose Remote control” link below to see the options in more detail. You will require 1 channel per Curtain track or Roller Blind assembly",
  PoleColour: "Select your desired pole colour. See pole colour images to the left.",
  Finial: "Select whether you would like finials. Finials come in sets of 2.",
  KitRequired: "<b>Self Cut</b> – you will be supplied with a 2m length of tube which you will need to cut yourself making allowances for the motor and brackets. <br><b>Factory Cut</b> – based on dimensions provided by you we will prepare the tube so it is ready for the blind fabric to be fitted. <br><b>TQL25 Battery Motor Only</b> – if you only require the motor that comes c/w charging cable select this option.  <br><b>PLEASE REFER TO THE DIY INSTRUCTIONS </b>",
  Tubewillbesuppliedat: "Guidance measurment for the length of tube you should expect to receive from us.",
  Cutyourfabrictothefollowingwidth: "Guidance measurement for cutting your blind fabric. Please cut your blind fabric to this width.",
  ChargingPlug: "Do you require a 3 pin UK Mains plug to go with the charging cable?  The charging cable is a Std USB to USB-C and is supplied with the motor FOC.",
  BrackettoBracketSizeMax2000mmMin520mm: "Outside of bracket to outside of bracket dimensions of where the blind will be mounted in mm.",
  BendsorBayWindows: "If you have a shaped window let us know the number of bends or whether it is a continuous curve for a bay.  This is for pricing purposes only, one of our team will be in touch for the exact details prior to making your track.",
  PairorSingleCurtain: "A pair of curtains is 2 curtains to cover the track width and a Single curtain is 1 curtain to cover the track width.",
  MotorSideLeftorRight: "Choose which side you would like the motor to be positioned.  It is the side where the power supply is coming from.",
  HeadrailWidth: "Select the Width range that your headrail will fall into",
"ActualHeadrailWidth(mm)": "Give the exact width that you would like your headrails manufactured to the nearest mm"

}
 
$(window).on("load", function() {
  
 	  document.querySelectorAll('.selector-wrapper').forEach((element) => {
        let label = $(element).find('label')
        let helpMessage = null
        let subString = label.text().replace('*','').replace(/\s/g, '')
        if(subString === "GliderType" && document.title.includes("Eazipole")){
         	subString = subString  + "Pole" 
        }
        if (helpMessages[subString] ) {
          helpMessage = helpMessages[subString]
          let html = `<i style="color:#E37222;padding-left:3px; white-space:pre" data-html="true" id="tooltip`+subString+`" title='' class="fa fa-info-circle"></i>`;
          label.html(label.text() + html)
          $("#tooltip"+subString).tooltip({
            content: helpMessage
		  });
        }
  	  });
  
  	  document.querySelectorAll('.bold_option_title').forEach((label) => {
        let helpMessage = null
        let subString = label.outerText.replace('*','').replace(/\s/g, '')
        if (helpMessages[subString]) {
          helpMessage = helpMessages[subString]
          let html = `<i style="color:#E37222;padding-left:3px; white-space:pre" data-html="true" id="tooltip`+subString+`" title='' class="fa fa-info-circle tooltip`+subString+`"></i>`;
          label.innerHTML = label.innerHTML + html
          $(".tooltip"+subString).tooltip()
          $(".tooltip"+subString).tooltip("option", "content" , helpMessage);
        }
  	  });
  
      document.querySelectorAll('.bold_option_textbox').forEach((element) => {
        let helpMessage = null
        const label = $(element).find("label");
        if (helpMessages[label.text().replace(/\s/g, '')] ) {
          helpMessage = helpMessages[subString]
          let html = `<i style="color:#E37222;padding-left:3px; white-space:pre" data-html="true" id="tooltip`+subString+`" title='' class="fa fa-info-circle"></i>`;
          label.html(label.text() + html)
          $("#tooltip"+subString).tooltip({
            content: helpMessage
		  });
        }
      });
  
    
      //Hide the finial colour options.
      $(poleColourOption).closest('.bold_option_swatch').show();
  
      //Loop through each option in the transmitter dropdown and append the price within square brackets
      $(".dd_830103_349812 > option").each(function(){                  
          this.text = this.text.indexOf("Standard - 7") >= 0 ? this.text + "[£18.70]" : this.text;      
          this.text = this.text.indexOf("Stylish - 6") >= 0 ? this.text + "[£33.08]" : this.text;
          this.text = this.text.indexOf("Stylish – 2") >= 0 ? this.text + "[£24.18]" : this.text;
          this.text = this.text.indexOf("4 Channel Wall") >= 0 ? this.text + "[£27.00]" : this.text;
          this.text = this.text.indexOf("2 Channel Wall") >= 0 ? this.text + "[£25.00]" : this.text;
      });
  
      //Loop through each option in the transmitter dropdown and append the price within square brackets
      $(".dd_830103_567369 > option").each(function(){                  
          this.text = this.text.indexOf("Standard - 7") >= 0 ? this.text + "[£18.70]" : this.text;      
          this.text = this.text.indexOf("Stylish - 6") >= 0 ? this.text + "[£33.08]" : this.text;
          this.text = this.text.indexOf("Stylish – 2") >= 0 ? this.text + "[£24.18]" : this.text;
          this.text = this.text.indexOf("4 Channel Wall") >= 0 ? this.text + "[£27.00]" : this.text;
          this.text = this.text.indexOf("2 Channel Wall") >= 0 ? this.text + "[£25.00]" : this.text;
      });
  
  
      //Loop through each option in the finial dropdown and append the price.
      $('.dd_807410_342509 > option').each(function() {
          this.text = this.text.indexOf("Set of 2") >= 0 ? this.text + "[£10.00]" : this.text;
      });
  });

  
  $(document).ready(function(){
  
      //Make sure that a user cannot de-select a colour swatch
      $(document).on('click', '.sw_830113_349812', function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();        
          $(".sw_830113_349812").prop( "checked", true );
      });
  
      $(document).on('click', '.sw_830139_349812', function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();        
          $(".sw_830139_349812").prop( "checked", true );
      });
  
      //Stylish 2 channel.
      $(document).on('click', '.sw_854652_349812', function (event) {
          event.stopPropagation();
          event.stopImmediatePropagation();        
          $(".sw_854652_349812").prop( "checked", true );
      });
    
    
    
(function () {
  // Bold's current configuration generates the leading-underscore classes.
  // Keep the old tb_ forms as fallbacks in case the app restores its subtype.
  var sourceSelector = '._1445135_567369, .tb_1445135_567369';
  var targetASelector = '._1452083_567369, .tb_1452083_567369';
  var targetBSelector = '._1452085_567369, .tb_1452085_567369';

  function setOptionValue(element, value) {
    if (!element || element.value === value) {
      return;
    }

    element.value = value;

    // Bold Product Options listens for "change" to store/recalculate values.
    element.dispatchEvent(new Event('input', { bubbles: true }));
    element.dispatchEvent(new Event('change', { bubbles: true }));
  }

  function update(source) {
    var targetA = document.querySelector(targetASelector);
    var targetB = document.querySelector(targetBSelector);

    if (!targetA || !targetB) {
      return;
    }

    var rawValue = String(source.value || '').replace(',', '.');
    var length = parseFloat(rawValue);

    if (Number.isFinite(length) && length > 519 && length <= 2000) {
      setOptionValue(targetA, (length - 28) + 'mm');
      setOptionValue(targetB, (length - 36) + 'mm');
    } else {
      setOptionValue(targetA, '');
      setOptionValue(targetB, '');
    }
  }

  function bindFields() {
    document.querySelectorAll(sourceSelector).forEach(function (source) {
      if (source.dataset.blindCalculationBound === 'true') {
        return;
      }

      source.dataset.blindCalculationBound = 'true';
      source.addEventListener('input', function () {
        update(source);
      });
      source.addEventListener('change', function () {
        update(source);
      });
      update(source);
    });
  }

  // The product-options app inserts these inputs asynchronously after page load
  // and may recreate them when conditional options change.
  var observer = new MutationObserver(bindFields);
  observer.observe(document.documentElement, {
    childList: true,
    subtree: true
  });

  bindFields();
})();


    
      $(".bold_option_title").each(function(i){
        let helpMessage = null
        let subString = this.outerText.replace('*','').replace(/\s/g, '')
        if (helpMessages[subString]) {
          helpMessage = helpMessages[subString]
          let html = `<i style="color:#E37222;padding-left:3px; white-space:pre" data-html="true" id="tooltip`+subString+`" title='' class="fa fa-info-circle tooltip`+subString+`"></i>`;
          this.innerHTML = this.innerHTML + html
          $(".tooltip"+subString).tooltip()
          $(".tooltip"+subString).tooltip("option", "content" , helpMessage);
        }
      });
      

      //If the form has validation errors, show the red validaiton message under the checkout button.
      var observer = new MutationObserver(function(mutations) {
          mutations.forEach(function(mutation) {
            //  console.log(mutation)
              if (mutation.addedNodes && mutation.addedNodes.length > 0) {
                  if (($(".dd_1457993_567369").val() == "Factory Cut") & !set){
                    $(".tb_1452083_567369").attr("disabled", "disabled")
                    $(".tb_1452085_567369").attr("disabled", "disabled")
                    set = true
                    $(".bold_option_title").each(function(i){
                      let subString = this.outerText.replace('*','').replace(/\s/g, '').replace('(', '').replace(')', '').replace(':', '')
                      if (["Tubewillbesuppliedat", "BrackettoBracketSizeMaximum2000mm", "Cutyourfabrictothefollowingwidth"].includes(subString)){
                        let helpMessage = null
                        if (helpMessages[subString]) {
                          helpMessage = helpMessages[subString]
                          let html = `<i style="color:#E37222;padding-left:3px; white-space:pre" data-html="true" id="tooltip`+subString+`" title='' class="fa fa-info-circle tooltip`+subString+`"></i>`;
                          this.innerHTML = this.innerHTML + html
                          $(".tooltip"+subString).tooltip()
                          $(".tooltip"+subString).tooltip("option", "content" , helpMessage);
                        }
                      }
                    });
                  }
                  // element added to DOM
                  var hasClass = [].some.call(mutation.addedNodes, function(el) {
                    try{
                      return el.classList.contains('bold_error_message')
                    }
                    catch{
                      return null 
                    }
                  });
                  if (hasClass) {
                      // element has class `MyClass`                    
                      $("#track_builder_form_invalid_info_text").show();
                  }else{
                      $("#track_builder_form_invalid_info_text").hide();
                  }
              }
          });
      });
            
      
      
      var config = {
          attributes: true,
          childList: true,
          characterData: true,
          subtree: true
      };
      
      var set = false
      observer.observe(document.body, config);
  });
     